enum DeletePageDialogFields {
	PAGERANGE = 'pagerange'
}

export default DeletePageDialogFields;